"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportScopeType = void 0;
var ReportScopeType;
(function (ReportScopeType) {
    ReportScopeType["DOMAIN"] = "DOMAIN";
    ReportScopeType["PPC"] = "PPC";
})(ReportScopeType = exports.ReportScopeType || (exports.ReportScopeType = {}));
